@if (breadcrumbSegments.length > 1) {
  <div>
    <nav aria-label="breadcrumb" data-qa="breadcrumb">
      <ol class="breadcrumb" [class.theme-color]="useThemeColor">
        @for (segment of breadcrumbSegments; track segment; let last = $last) {
          <li class="breadcrumb-item" [class.active]="last">
            @if (!last && segment.callback) {
              <a
                (click)="segment.callback()"
                (keyup.enter)="segment.callback()"
                tabindex="0"
                [class.colored-breadcrumb]="useThemeColor"
              >
                {{ segment.text }}
              </a>
            } @else if (!last && segment.link) {
              <a
                (click)="navigateToLink(segment.link)"
                (keyup.enter)="navigateToLink(segment.link)"
                tabindex="0"
                [class.colored-breadcrumb]="useThemeColor"
              >
                {{ segment.text }}
              </a>
            } @else {
              <span [class.colored-breadcrumb]="useThemeColor">
                {{ segment.text }}
              </span>
            }
          </li>
        }
      </ol>
    </nav>
  </div>
}
